import styled from 'styled-components';
import quotes from '../../assets/images/quotes.svg';

const StyledInputContainer = styled.div`
	width: 100%;
	margin-top: 36px;
`;

const StyledButtonContainer = styled.div`
	width: 100%;
	margin-top: 20px;
`;

const StyledQuotes = styled.div`
	position: absolute;
	top: 60px;
	left: 50%;
	transform: translateX(-50%);
	width: 86px;
	height: 62px;
	background-image: url(${quotes});
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
`;

export { StyledInputContainer, StyledButtonContainer, StyledQuotes };
